export const validatePhoneNumber = backendPhone => {
  // example: "+12224446666"
  const number = backendPhone.substr(2);
  return (
    backendPhone.length === 12 &&
    backendPhone[0] === "+" &&
    backendPhone[1] === "1" &&
    +number + "" === number
  );
};

export const backendPhoneNumberToDisplay = backendPhone => {
  let result = "";
  if (backendPhone.length === 0) {
    return result;
  }
  backendPhone = backendPhone.substr(2);
  result += "(";
  result += backendPhone.substr(0, 3);
  backendPhone = backendPhone.substr(3);
  if (backendPhone.length === 0) {
    return result;
  }
  result += ") ";
  result += backendPhone.substr(0, 3);
  backendPhone = backendPhone.substr(3);
  if (backendPhone.length === 0) {
    return result;
  }
  result += "-";
  result += backendPhone.substr(0, 4);
  return result;
};

export const displayPhoneNumberToBackend = displayPhone => {
  const justNumbers = displayPhone.replace(/[^0-9]/g, "").substr(0, 10);
  if (justNumbers === "") {
    return "";
  }
  return "+1" + justNumbers;
};



// WEBPACK FOOTER //
// ./frontend/src/util/phone.js